// extracted by mini-css-extract-plugin
module.exports = {"text":"text_text__15iQE","bold":"text_bold__3Zzmr","fontSize16":"text_fontSize16__2_ko1"};